// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"companyvideo__videoWrapper___gQj0J","playerWrapper":"companyvideo__playerWrapper___Utc8H","placeHolderShimmer":"companyvideo__placeHolderShimmer___2L0Gz"};